<template>
  <div class="form-wrapper">
    <h2>Add Task</h2>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label>Title</label>
        <input v-model="task.title" type="text" placeholder="Task Title" required />
      </div>
      <div class="form-group">
        <label>Description</label>
        <textarea v-model="task.description" placeholder="Task Description"></textarea>
      </div>
      <div class="form-group">
        <label>Assigned To (Worker)</label>
        <select v-model="task.worker_id">
          <option v-for="worker in workers" :key="worker.id" :value="worker.id">{{ worker.name }}</option>
        </select>
      </div>
      <div class="form-group">
        <label>Due Date</label>
        <input v-model="task.due_date" type="date" />
      </div>
      <button class="btn btn-gradient" type="submit">
        <span v-if="loading">Saving...</span>
        <span v-else>Save Task</span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'AddTaskComponent',
  data() {
    return { task: { title: '', description: '', worker_id: '', due_date: '' }, loading: false, workers: [] };
  },
  methods: {
    fetchWorkers() { this.workers = this.$store.state.workers.items || []; },
    submitForm() {
      this.loading = true;
      this.$store.dispatch('tasks/addTask', this.task)
        .then(() => this.$router.push({ name: 'Tasks' }))
        .finally(() => this.loading = false);
    }
  },
  mounted() { this.fetchWorkers(); }
};
</script>
